var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCreditCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4 4a3 3 0 00-3 3v1a1 1 0 001 1h20a1 1 0 001-1V7a3 3 0 00-3-3H4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1 12a1 1 0 011-1h20a1 1 0 011 1v5a3 3 0 01-3 3H4a3 3 0 01-3-3v-5zm4 3a1 1 0 011-1h5a1 1 0 110 2H6a1 1 0 01-1-1z",
    clipRule: "evenodd"
  })));
}

export default SvgCreditCard;